import firebase, { db } from "../firebase";
let uid: any = "";
export const login = async (email: any, password: any) => {
  const usersSnapShot = await db.collection("MAHOPUser").get();
  const users: any[] = [];
  usersSnapShot.forEach((doc: { data: () => any }) => {
    const data = doc.data();
    users.push(data);
  });

  let user = await firebase.auth().signInWithEmailAndPassword(email, password);
  for (let i = 0; i < users.length; i++) {
    if (users[i].Schema?.uid.value === user?.user?.uid) {
      return { ...users[i] };
    }
  }
  //   Will should never get here...
  throw Error;
};
export const signup = async (
  firstName: any,
  lastName: any,
  email: any,
  phoneNumber: any,
  password: any
) => {
  try {
    const user: any = await firebase
      .auth()
      .createUserWithEmailAndPassword(email, password);
    uid = user?.user?.uid;
  } catch (e) {
    console.log("e:", e);

    return e;
  }
  const userData: any = { firstName, lastName, email, phoneNumber, uid };

  console.log(userData);
  await db.collection("SEJWFUser").doc(userData?.uid).set(userData);
  // console.log("Sign up===>", userData);
  return { ...userData };
};
export const signInAnonymously = async (
  firstName: any,
  lastName: any,
  email: any,
) => {
  try {
    const user: any = await firebase
      .auth()
      .signInAnonymously()
      .then(async () => {
        // uid = user?.user?.uid;
        await firebase.auth().onAuthStateChanged((user) => {
          if (user) {
           
            uid = user.uid;
           
          } else {
            // User is signed out
            console.log("User is signed out--->");
          }
        });
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log("errorMessage--->", errorMessage);
      });
  } catch (e) {
    console.log("e:", e);

    return e;
  }
  const userData: any = { firstName, lastName, email, uid };

  console.log(userData);
  await db.collection("SEJWFUser").doc(userData?.uid).set(userData);
  // console.log("Sign up===>", userData);
  return { ...userData };
};

export const userData = async (id: any) => {
  const snapShot = await db.collection("SEJWFUser").doc(id).get();
  const data: any = snapShot.data();
  return { ...data };
};

